import { CSS as MenuCSS } from '../../components/menu/menu.style';

export const CSS = {
	container: 'c-UpdateFormCollections',
	isLoading: 'c-UpdateFormCollections--IsLoading',
	content: 'c-UpdateFormCollections__Content',
	contentSecond: 'c-UpdateFormCollections__Content__second',
	list: 'c-UpdateFormCollections__List',
	menu: 'c-UpdateFormCollections__Menu',
	warningContainer: 'c-UpdateFormCollections__Warning',
	warningTitle: 'c-UpdateFormCollections__Warning__Title',
	warningBody: 'c-UpdateFormCollections__Warning__Body',
	warningList: 'c-UpdateFormCollections__Warning__List',
};

export const Style = {
	[CSS.container]: {
		width: '1000px',
	},
	[CSS.isLoading]: {
		display: 'flex',
		'justify-content': 'center',
	},
	[CSS.content]: {
		display: 'flex',
		'align-items': 'baseline',
		'justify-content': 'space-around',
	},
	[CSS.contentSecond]: {
		display: 'flex',
		'align-items': 'baseline',
		'justify-content': 'space-between',
	},
	[CSS.list]: {
		'list-style-type': 'none',
		'padding-left': 0,
	},
	[CSS.menu]: {
		width: '600px',
		position: 'absolute',
		[`& .${MenuCSS.menu}`]: {
			right: 'auto',
			width: '100%',
		},
	},
	[CSS.warningTitle]: {
		color: 'red',
		'font-size': '2rem',
		'padding-bottom': '1rem',
	},
	[CSS.warningBody]: {
		'padding-bottom': '1rem',
	},
	[CSS.warningList]: {
		'padding-bottom': '1rem',
	},
};
